import {Component} from '@angular/core';
import {AlertController, NavController} from 'ionic-angular';
import {ContactEditPage} from "../contact-edit/contact-edit";

@Component({
  selector: 'page-contact-view',
  templateUrl: 'contact-view.html'
})
export class ContactViewPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController, private alertCtrl: AlertController) {
  }

  goToContactEdit(params) {
    if (!params) params = {};
    this.navCtrl.push(ContactEditPage);
  }
  onMailTo(params) {
    if (!params) params = {};
    let Link="mailto:team@limelyte.com";
    window.open(Link, "_system");
  }
  onSMS(params) {
    if (!params) params = {};
    let Link="sms:5092410138";
    window.open(Link, "_system");
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      title: 'Add Contact to Group',
      subTitle: 'Could just show a list of groups to add contact to; with single or multiple select. However, ' +
      'should consider ownership of the group.  Can anyone in the group add to the group or are their group rights?',
      buttons: ['Dismiss']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact-view/contact-view.ts